<template>
  <v-container>
    <v-alert type="error" icon="fas fa-exclamation" elevation="2" dense :value="error != ''" dismissible>{{error}}</v-alert>
    <v-row>
      <v-col>
        <div style="margin-left: 15px; display: grid !important;">
          <h2>Welcome {{loggedInUser?.FirstName}} {{loggedInUser?.Surname}}</h2>
          <v-subheader>{{loggedInUser?.Email}}</v-subheader>
          <v-subheader>{{loggedInUser?.PhoneNumber}}</v-subheader>
        </div>
      </v-col>
      <v-col>
        <h4 style="margin-left: 35px; margin-bottom: 10px;">Filter applies to all dashboard reports</h4>
        <v-select 
          outlined 
          label="Filter by Location" 
          item-text="LocationName" 
          item-value="LocationID" 
          v-model="selectedLocationID"
          :items="items.results" 
          clearable
          style="min-width: 200px;"
          prepend-icon="mdi-filter"
          :dense="true"
          :menu-props="{ top: false, offsetY: true }"></v-select>
      </v-col>
    </v-row>
    <v-divider class="divider"></v-divider>
    <v-row align="start" justify="center">
      <v-col>
        <div class="infoLinkContainer">
          <h4 class="infoLinkDetails">Upcoming Jobs</h4>
          <router-link :to="`/jobs?status=upcoming${selectedLocationID == null ? '' : '&locationId='+selectedLocationID}`">View All</router-link>
        </div>
        <UpcomingJobList :locationID="selectedLocationID" :clientID="selectedClientID" @onLoad="errorHandler"></UpcomingJobList>
        <div class="infoLinkContainer">
          <p class="infoLinkDetails">Jobs missing or details incorrect?</p>
          <a href="https://servicefm.com.au/contact/" target="_blank">Contact Us</a>
        </div>
      </v-col>
      <v-col align="center">
        <JobsByStatusPieGraph :locationID="selectedLocationID" :clientID="selectedClientID" @onLoad="errorHandler"></JobsByStatusPieGraph>
      </v-col>
    </v-row>
    <v-divider class="divider"></v-divider>
    <v-row>
      <v-col>
        <div class="infoLinkContainer">
          <h4 class="infoLinkDetails">Recent Job Reports (last 10)</h4>
          <router-link :to="`reports${selectedLocationID == null ? '' : '?locationId='+selectedLocationID}`">View All</router-link>
        </div>
        <RecentJobReportsList :locationID="selectedLocationID" :clientID="selectedClientID" @onLoad="errorHandler"></RecentJobReportsList>
        <div class="infoLinkContainer">
          <p class="infoLinkDetails">Have a question?</p>
          <a href="https://servicefm.com.au/contact/" target="_blank">Contact Us</a>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator';
import UpcomingJobList from '@/components/dashboard/UpcomingJobsList.vue';
import JobsByStatusPieGraph from '@/components/dashboard/JobsByStatusPieGraph.vue';
import RecentJobReportsList from '@/components/dashboard/RecentJobReportsList.vue';
import * as LocationAPI from '@/api/locationAPI';
import PaginatedResults from '../../../shared/models/paginatedResults';
import * as UserAPI from '@/api/userAPI';
import User from '../../../shared/models/user';
import Location from '../../../shared/models/location';
import { vxm } from '@/store';

@Component({
  components: {
    UpcomingJobList,
    JobsByStatusPieGraph,
    RecentJobReportsList
  },
})
export default class DashboardView extends Vue {
  private error = "";
  private selectedLocationID: string | null = null;
  private selectedLocationName: string | null = null;
  private loggedInUser: User | null = null;

  private items: PaginatedResults<Location> = {
    totalResults: 0,
    results: []
  };

  
  get selectedClientID() { return  vxm.AuthStore.targetClient?.ClientID; }
  private async mounted() {
    try {
      this.loggedInUser = await UserAPI.getLoggedInUser();
      if(this.selectedClientID === undefined){
        throw new Error("No client selected");
      }
      this.items = await LocationAPI.getLocations(1, -1,'LocationName', false, null, null, null, null);
    }
    catch (ex) {
      this.error = (ex as Error).message;
    }
  }

  private errorHandler(ex: Error) {
    this.error = ex.message;
  }

  @Watch('selectedLocationID', { immediate: true, deep: true })
  onItemChanged() {
    this.selectedLocationName == null;
    if (this.selectedLocationID == null) { return; }

    for (let i = 0; i < this.items.results.length; i++) {
      if (this.items.results[i].LocationID == this.selectedLocationID) {
        this.selectedLocationName = this.items.results[i].LocationName;
        return;
      }
    }
  }

  @Watch('selectedClientID', { immediate: true, deep: true })
  async onClientIDChanged() {
    this.items = await LocationAPI.getLocations(1, -1,'LocationName', false, null, null, null, null);
  }
}
</script>

<style>
.divider {
  margin-bottom: 20px;
}
.infoLinkContainer {
  margin-left: 15px;
}
.infoLinkDetails {
  float: left; 
  margin-right: 10px;
}
.v-menu__content {
  max-height: 600px !important;
}
.v-subheader {
  height: 25px;
  padding: 0px;
}
</style>